<template>
    <div class="container-fluid form-container nurse-call-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Nurse Call System Service Report / Certificate
                </h1>
            </div>
        </div>

        <form
            action=""
            class="handover-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="getJobs()"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="customer_order_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <job-info
                v-if="form.job_id"
                :job-id="form.job_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>System Details</h3>
                        </div>
                    </div>
                    <select-row-component
                        id="service_type"
                        label="What service are you carrying out?"
                        v-model="form.service_type"
                        :options="[
                            'Routine service',
                            'Full new service - system takeover',
                            'Non-routine service / Repair',
                        ]"
                    />
                    <text-row-component
                        id="system_manuf"
                        label="Nurse call system type / manufacturer"
                        v-model="form.system_manuf"
                    />
                    <text-row-component
                        id="protocol_series_number"
                        label="Nurse call system protocol or series number"
                        v-model="form.protocol_series_number"
                    />
                    <text-row-component
                        id="system_location"
                        label="Location of nurse call system"
                        v-model="form.system_location"
                    />
                    <file-upload-row-component
                        id="nurse_call_photo"
                        label="Photo of nurse call system"
                        v-model="form.nurse_call_photo"
                    />
                    <text-row-component
                        id="panel_user_code"
                        label="Panel user code"
                        v-model="form.panel_user_code"
                    />
                    <text-row-component
                        id="panel_engineer_code"
                        label="Panel engineer code"
                        v-model="form.panel_engineer_code"
                    />

                    <select-row-component
                        id="panel_working"
                        label="Nurse Call Panel working correctly and ancillary functions lamp test been tested?"
                        v-model="form.panel_working"
                    />
                    <select-row-component
                        id="panel_buzzer_working"
                        label="Nurse Call Panel buzzer work correctly?"
                        v-model="form.panel_buzzer_working"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Power Supplies</h3>
                        </div>
                    </div>
                    <select-row-component
                        id="cie_battery_qty"
                        label="Quantity of Control Indication Equipment (CIE) Batteries"
                        v-model="form.cie_battery_qty"
                        :options="['1', '2', '3', '4',]"
                    />
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr
                                    v-for="(battery, index) in form.batteries"
                                    :key="index"
                                >
                                    <td>
                                        <label>Battery {{ index + 1 }}</label>
                                    </td>
                                    <td>
                                        <label>Size (AMP)</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="battery.size"
                                            placeholder="2.1"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Volts</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="battery.volts"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Amps</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="battery.amps"
                                        >
                                    </td>
                                    <td>
                                        <label>Year</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="1"
                                            min="1990"
                                            class="form-control"
                                            v-model="battery.year"
                                        >
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <select-row-component
                        id="batteries_working"
                        label="Are batteries installed in date & working order?"
                        v-model="form.batteries_working"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Device List</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 10rem">
                                            Device No.
                                        </th>
                                        <th style="width: 17rem">
                                            Device Type
                                        </th>
                                        <th colspan="2">
                                            Location
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(device, index) in form.devices"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                v-model="device.number"
                                                type="text"
                                                class="form-control"
                                                placeholder="Device No."
                                            >
                                        </td>
                                        <td>
                                            <select
                                                v-model="device.type"
                                                class="form-control"
                                            >
                                                <option value="">
                                                    Select
                                                </option>
                                                <option>Call point</option>
                                                <option>Display screen</option>
                                                <option>Sounder</option>
                                                <option>Monitoring point</option>
                                                <option>Computer connection</option>
                                                <option>Pull cord</option>
                                                <option>Light</option>
                                                <option>Repeater panel</option>
                                                <option>Network splitter</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.location"
                                                type="text"
                                                class="form-control"
                                                placeholder="Location"
                                            >
                                        </td>
                                        <td
                                            class="text-right"
                                            style="width: 3rem"
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click.prevent="removeDevice(index)"
                                                :disabled="form.devices.length <= 1"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right">
                                <button
                                    class="btn btn-secondary"
                                    @click.prevent="loadSiteDevices"
                                    :disabled="!this.form.site_id"
                                >
                                    <i class="fa fa-download" /> Load site devices
                                </button>
                                <button
                                    class="btn btn-primary"
                                    @click.prevent="addDevice"
                                >
                                    <i class="fa fa-plus" /> Add Device
                                </button>
                            </div>
                        </div>
                    </div>

                    <select-row-component
                        id="any_devices_failed"
                        label="Have any devices failed?"
                        v-model="form.any_devices_failed"
                    />
                </div>
            </div>

            <div
                class="card"
                v-if="form.any_devices_failed === 'Yes'"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Failed Devices</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 10rem">
                                            Device No.
                                        </th>
                                        <th colspan="2">
                                            Recommendation
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(device, index) in form.failed_devices"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                v-model="device.number"
                                                type="text"
                                                class="form-control"
                                                placeholder="Device No."
                                            >
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.recommendation"
                                                type="text"
                                                class="form-control"
                                                placeholder="Recommendation"
                                            >
                                        </td>
                                        <td
                                            class="text-right"
                                            style="width: 3rem"
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click.prevent="removeFailedDevice(index)"
                                                :disabled="form.failed_devices.length <= 1"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right">
                                <button
                                    class="btn btn-primary"
                                    @click.prevent="addFailedDevice"
                                >
                                    <i class="fa fa-plus" /> Add Device
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Observations and Recommendations</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                v-model="form.recommendations"
                                rows="4"
                                placeholder="Type recommendations here..."
                                class="form-control mb-2"
                            />
                            <div class="text-right">
                                <button
                                    type="button"
                                    @click.prevent="autofillRecommendations"
                                    class="btn btn-primary"
                                >
                                    Autofill Recommendations
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Logs and Final Checks</h3>
                        </div>
                    </div>

                    <select-row-component
                        id="system_operational"
                        label="System left fully operational?"
                        v-model="form.system_operational"
                    />

                    <select-row-component
                        id="system_fault_free"
                        label="System left fully fault free?"
                        v-model="form.system_fault_free"
                    />

                    <select-row-component
                        id="recommendations_recorded"
                        label="Have all recommendations, outstanding issues and non-complances been recorded and reported to the responsible person?"
                        v-model="form.recommendations_recorded"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Notes</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                v-model="form.notes"
                                rows="4"
                                placeholder="Type notes here..."
                                class="form-control mb-2"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h3>Signoff</h3>
                    <p>
                        I declare that I am a competent person (CP) in Nurse Call system maintenance.
                        All equipment returned to normal Serviced.
                    </p>
                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select-component
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                name="engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>
                                Accepted, For and behalf of the user, by Responsible Person (RP).
                                I understand that the system is operating as designed I understand that if any items, were shown to be defective, may affect to performance of the nurse call system.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature-component
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                name="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isLoading || isSaving"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isLoading || isSaving"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit'"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit'"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import AuthService from "../../services/AuthService";
import moment from "moment";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import Sortables from "../../mixins/Sortables";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import FormService from "../../services/FormService";
import JobService from "../../services/JobService";
import Service from "../../services/FormService";
import CustomerSearch from "../CustomerSearch.vue";
import JobInfo from "./parts/JobInfoComponent.vue";
import SelectRowComponent from "./parts/SelectRowComponent.vue";
import TextRowComponent from "./parts/TextRowComponent.vue";
import FileUploadRowComponent from "./parts/FileUploadRowComponent.vue";
import SignatureComponent from "../SignatureComponent.vue";
import UserSelectComponent from "../UserSelectComponent.vue";
import DatePicker from "../DateTimePickerComponent.vue";
import SitesService from "../../services/SitesService";

const initialDevice = {
    number: '',
    type: '',
    location: '',
};

const initialFailedDevice = {
    number: '',
    recommendation: '',
};

const initialForm = {
    type: "nurse_call",
    customer: {
        company_name: "",
    },
    job_id: '',
    site_id: '',
    engineer_sign_date: moment(),
    customer_sign_date: moment(),
    service_type: '',
    system_manuf: '',
    protocol_series_number: '',
    system_location: '',
    panel_user_code: '',
    panel_engineer_code: '',
    panel_working_correctly: '',
    panel_buzzer_working: '',
    cie_battery_qty: '1',
    batteries_working: '',
    devices: [
        {...initialDevice},
    ],
    failed_devices: [
        {...initialFailedDevice},
    ],
    recommendations: '',
    recommendations_recorded: '',
    system_fault_free: '',
    system_operational: '',
    notes: '',
};

export default {
    components: {
        UserSelectComponent,
        SignatureComponent,
        FileUploadRowComponent,
        TextRowComponent,
        SelectRowComponent,
        CustomerSearch,
        JobInfo,
        DatePicker,
    },
    mixins: [UsesErrors, UsesInfoMessage, Sortables, UsesFormRouteQuery],
    data() {
        return {
            changed: false,
            sites: [],
            customerSignature: null,
            jobs: [],
            form: {...initialForm},
            materials: [],
            token: null,
            companyName: window.SystemSettings.company_name,
        };
    },
    computed: {
        canDelete() {
            return (
                AuthService.user.admin_access || AuthService.user.office_access
            );
        },
        batteryQty() {
            return parseInt(this.form.cie_battery_qty || 0);
        },
        devices() {
            return this.form.devices.filter(d => d.number !== '');
        },
    },
    watch: {
        batteryQty: {
            immediate: true,
            handler: function () {
                this.batteryQtyChanged();
            },
        },
    },
    mounted: function () {
        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then((res) => {
                this.form.doc_no = res.data;
            });
        }

    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id)
                .then(
                    (res) => {
                        this.form = {...initialForm, ...res.data};
                        if (res.data.engineer_sign_date) {
                            this.form.engineer_sign_date = moment(
                                res.data.engineer_sign_date
                            );
                        }
                        if (res.data.customer_sign_date) {
                            this.form.customer_sign_date = moment(
                                res.data.customer_sign_date
                            );
                        }
                        this.getJobs();
                    },
                    (err) => {
                        this.setErrorMessage("Could not load form");
                        console.error(err);
                    }
                )
                .then(() => {
                    this.clearLoading();
                });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                }
            } else {
                this.form.site_id = '';
            }
            this.getJobs();
        },
        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                (err) => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        },
        saveForm: function () {
            this.setSaving();
            this.clearErrors();
            if (
                this.$refs.customerSignature &&
                !this.$refs.customerSignature.isEmpty()
            ) {
                this.form.customer_signature =
                    this.$refs.customerSignature.toPng();
            }

            let data = {...this.form};
            data.devices = (data.devices || []).filter(device => !!device.number && !!device.location && !!device.type)
            delete data["customer"];
            delete data["site"];
            delete data["job"];
            delete data["data"];

            if (this.form.id) {
                Service.update(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit("formSaved", res.data);
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes("engineer/")) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        }
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    (xhr) => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: "office.forms.search"});
                    },
                    (error) => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                );
            }
        },

        batteryQtyChanged() {
            const batteries = [...this.form.batteries || []];
            while (batteries.length < this.batteryQty) {
                batteries.push({});
            }
            while (batteries.length > this.batteryQty) {
                batteries.splice(-1, 1);
            }
            this.form.batteries = batteries;
        },

        removeDevice(index) {
            this.form.devices.splice(index, 1);
        },

        addDevice() {
            this.form.devices.push({...initialDevice});
        },

        removeFailedDevice(index) {
            this.form.failed_devices.splice(index, 1);
        },

        addFailedDevice() {
            this.form.failed_devices.push({...initialFailedDevice});
        },
        autofillRecommendations() {
            const a = 'Engineer recommends panel / ancillary functions to be repaired or replaced to full working order.';
            const b = 'Repair / replace Nurse Call panel buzzer.';
            const c = 'Batteries installed for Nurse call system need replacing.';

            if (this.form.panel_working === 'No') {
                this.appendRecommendation(a)
            }

            if (this.form.panel_buzzer_working === 'No') {
                this.appendRecommendation(b)
            }

            if (this.form.batteries_working === 'No') {
                this.appendRecommendation(c)
            }
        },
        appendRecommendation(recommendation) {
            if (this.form.recommendations.includes(recommendation)) {
                return;
            }
            if (this.form.recommendations !== '') {
                this.form.recommendations += '\n';
            }

            this.form.recommendations += recommendation;
        },
        loadSiteDevices() {
            if (this.devices.length > 0) {
                const confirm = window.confirm(`Loading devices from the site with remove the ${this.devices.length} devices on this form, are you sure?`);
                if (!confirm) {
                    return;
                }
            }
            SitesService.get(this.form.site_id).then(({data}) => {
                this.form.devices = data.nurse_call_devices || [{...initialDevice}];
                this.setInfoMessage('Devices loaded successfully');
            });
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/NurseCallForm.vue